/**
 * 구독 상태 표시 매핑 — 라벨·StatusTag tone 의 SSoT(도메인 상태→tone 매핑은 feature 가 소유).
 */
import type { StatusTone } from '@/components/common';

import type { SubscriptionStatus } from '../types';

export const SUBSCRIPTION_STATUS_LABEL: Record<SubscriptionStatus, string> = {
  TRIAL: '무료 체험',
  ACTIVE: '구독중',
  EXPIRED: '만료됨',
  PAST_DUE: '결제 유예 중',
  CANCELED: '해지됨',
  CONVERTED: '유료 전환됨',
};

export const SUBSCRIPTION_STATUS_TONE: Record<SubscriptionStatus, StatusTone> = {
  TRIAL: 'info',
  ACTIVE: 'success',
  EXPIRED: 'destructive',
  PAST_DUE: 'warning',
  CANCELED: 'neutral',
  CONVERTED: 'success',
};

/** 만료 임박 배너 기준 잔여일. */
export const REMAINING_DAYS_THRESHOLD = 3;

/** 결제 실패 dunning 정책(확정값) — 3일 유예 + 2회 재시도. */
export const DUNNING_GRACE_DAYS = 3;
export const DUNNING_RETRY_COUNT = 2;
